import $ from 'jquery';

function imageHover() {
  $(".c-image-hover_list li div").hover( function() {
    var value=$(this).attr('data-src');
    var $wrapper=$(this).parents('.c-image-hover_wrapper');
    $wrapper.find(".c-image-hover_image-holder").attr("srcset", value);
  });
};

export { imageHover };